@let chart = chartConfig();
<google-chart [title]="chart.title" [type]="chart.type" [data]="chart.data" [columns]="chart.columnNames"
  [options]="chart.options" [dynamicResize]="true" style="width: 100%;">
</google-chart>
